export default __webpack_public_path__ + "static/waterSplash-046f1aa740ef9328c279b533278393bc.jpg";